export enum AppFeatureEnum {
    Schedules = 1,
    Recordables = 2,
    PurchaseOrders = 3,
    Service = 4,
    BWP = 5,
    BQA = 6,
    Portal = 999
}
